module.exports = {
  genesysChatComponentEvents: {
    MessengerOpened: {
      code: 'GENESYSCHATOPEN',
      events: {
        Opened: {
          description: 'Triggered when the Genesys Messenger is opened',
          eventHub: {
            code: 'GENESYSCHATOPEN',
            action: 'Genesys Messenger Opened',
            dataKeys: ['location', 'hasRESP']
          }
        }
      }
    },
    MessengerClosed: {
      code: 'GENESYSCHATCLOSE',
      events: {
        Closed: {
          description: 'Triggered when the Genesys Messenger is closed',
          eventHub: {
            code: 'GENESYSCHATCLOSE',
            action: 'Genesys Messenger Closed',
            dataKeys: ['location', 'hasRESP']
          }
        }
      }
    }
  }
};
